import script from "./CaseStudies.vue?vue&type=script&setup=true&lang=js"
export * from "./CaseStudies.vue?vue&type=script&setup=true&lang=js"

import "./CaseStudies.vue?vue&type=style&index=0&id=0e18f527&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e18f527"]])

export default __exports__